import styled from "styled-components";

export const KanbanCardActions = styled.div``;
export const ButtonGroup = styled.div`
  position: relative;
  top: -28px;
  right: 1px;
  width: 30px;
  float: right;

  &.open svg {
    color: #402680;
    transform: scale(1.15) rotate(30deg);
  }
`;

export const Actions = styled.ul`
  border: 1px solid #bdbdbd;
  position: absolute;
  top: 38px;
  left: -148px;
  right: 15px;
  min-width: 185px;

  &::after,
  &::before {
    bottom: 100%;
    right: 8px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: #ffffff;
    border-width: 6px;
    margin-right: 0px;
  }
  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-bottom-color: #bdbdbd;
    border-width: 8px;
    margin-right: -2px;
  }
`;

export const ActionsButton = styled.button`
  background: transparent;
  border-radius: 4px;
  padding: 8px 12px;
  transition: border 0.25s linear, color 0.25s linear,
    background-color 0.25s linear;
  border: none;
  font-size: 15px;
  font-weight: normal;

  &:focus {
    outline: 0;
  }

  &:focus {
    color: red;
  }

  svg {
    color: #525252;
    color: ${(props) => props.isDragging && "#fff"};
    font-size: 1.3em;
    transition: 0.1s ease-in-out;
  }
`;

export const ListActionItem = styled.li`
  width: calc(100% - 20px);
  padding: 2px 5px;
  margin: 2px 10px;
  background: #fff;
  transition: 0.1s ease-in-out;
  border-radius: 4px;
  color: #333;
  font-weight: 500;

  &:hover {
    background: #79D9D9;
    color: #fff;
    cursor: pointer;
  }
`;
ListActionItem.displayName = "ListActionItem";
